export default __webpack_public_path__ + "static/media/icon-check.2f4ae1ef.svg";